export const OPEN_TRANSCRIPTOR_RECORDING_PARAM = 'openTranscriptorRecording';

export const HANDLED_PRESIGN_SIGNATURE_STORAGE_KEY =
  'transcriptorDeepLinkHandledPresignSignature';

export const TRANSCRIPTOR_LANDING_PATIENT_ID_PARAM = 'patientID';
